import { getUserAnnouncements, upsertUserAnnouncement } from "../../api/announcementController";

export const editAnnouncementDataMarkAsSeen = async ({
	announcementId,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await upsertUserAnnouncement(
			announcementId,
			null
		);

		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const editAnnouncementDataMarkAsAcknowledged = async ({
	announcementId,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await upsertUserAnnouncement(
			announcementId,
			true
		);

		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchUserAnnouncements = async ({
	setAnnouncements,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		const response = await getUserAnnouncements();

		if (!!response?.success) {
			setAnnouncements(response.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
}